import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

export type ConfigValue = {
  api: {
    customHeader: string;
  };
  site: {
    name: string;
    serverUrl: string;
    assetURL: string;
    basePath: string;
    version: string;
    privacyPolicyUrl: string;
    termsAndConditionsUrl: string;
    refundAndCancellationPolicyUrl: string;
    phoneNumber: string;
    email: string;
    address: string;
    socialMedia: {
      twitter: string;
      facebook: string;
      instagram: string;
      linkedin: string;
    };
    appStore: {
      googlePlay: string;
      appleAppStore: string;
    };
  };
  auth: {
    method: 'jwt';
    skip: boolean;
    redirectPath: string;
  };
  firebase: {
    appId: string;
    apiKey: string;
    projectId: string;
    authDomain: string;
    storageBucket: string;
    measurementId: string;
    messagingSenderId: string;
    vapidKey: string;
  };
  sentry: {
    url: string;
  };
  noImage: string;
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  api: {
    customHeader: import.meta.env.VITE_CUSTOM_HEADER ?? '',
  },
  site: {
    name: 'Spark',
    serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
    assetURL: import.meta.env.VITE_ASSET_URL ?? '',
    basePath: import.meta.env.VITE_BASE_PATH ?? '',
    version: '6.0.0',
    privacyPolicyUrl: import.meta.env.VITE_PRIVACY_POLICY_URL ?? '',
    termsAndConditionsUrl: import.meta.env.VITE_TERMS_AND_CONDITIONS_URL ?? '',
    refundAndCancellationPolicyUrl:
      import.meta.env.VITE_REFUND_AND_CANCELLATION_POLICY_URL ?? '',
    phoneNumber: import.meta.env.VITE_PHONE_NUMBER ?? '',
    email: import.meta.env.VITE_EMAIL ?? '',
    address: import.meta.env.VITE_ADDRESS ?? '',
    socialMedia: {
      twitter: import.meta.env.VITE_SOCIAL_TWITTER_URL ?? '',
      facebook:
        import.meta.env.VITE_SOCIAL_FACEBOOK_URL ??
        'https://www.facebook.com/profile.php?id=61562802101381',
      instagram:
        import.meta.env.VITE_SOCIAL_INSTAGRAM_URL ??
        'https://www.instagram.com/sparkplatform/',
      linkedin:
        import.meta.env.VITE_SOCIAL_LINKEDIN_URL ??
        'https://www.linkedin.com/company/sparkentertainmentplatform/posts/?feedView=all',
    },
    appStore: {
      googlePlay:
        import.meta.env.VITE_APP_STORE_GOOGLE_PLAY_URL ??
        'https://play.google.com/store/apps/details?id=com.apessmartsolutions.spark',
      appleAppStore:
        import.meta.env.VITE_APP_STORE_APPLE_URL ??
        'https://apps.apple.com/ae/app/spark-entertainment/id6739362680',
    },
  },
  /**
   * Auth
   * @method jwt
   */
  auth: {
    method: 'jwt',
    skip: false,
    redirectPath: paths.tenant.root,
  },

  /**
   * Firebase
   */
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '',
    appId: import.meta.env.VITE_FIREBASE_APPID ?? '',
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? '',
    vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY ?? '',
  },
  sentry: {
    url: import.meta.env.VITE_SENTRY_URL ?? '',
  },
  noImage:
    'https://storage.googleapis.com/proudcity/mebanenc/uploads/2021/03/placeholder-image-768x576.png',
};
